import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import UpdateLeagueScore from "./UpdateLeagueScore";
import { useDispatch } from "react-redux";
import { uiInfoActions } from "../../../actions";

const ListLeagueScore = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const quarters = useSelector((state) => state.publishedQuarter.data);
  const states = useSelector((state) => state.states.data);

  useEffect(() => {
    dispatch(uiInfoActions.publishedQuarter());
    dispatch(uiInfoActions.state());
  }, []);

  if (states && quarters) {
    return (
      <UpdateLeagueScore quarters={quarters} states={states} token={token} />
    );
  } else {
    return <></>;
  }
};

export default ListLeagueScore;
